<template>
  <div class="plantSetting">
    <div class="header">
      <el-tabs :value="tabPaneValue" @tab-click="tabPaneClick">
        <el-tab-pane label="组织结构" name="first">
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'table' }"
            @click="settingChange('table')"
            >组织结构</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTree' }"
            @click="settingChange('orgTree')"
            >组织结构树</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTypeTable' }"
            @click="settingChange('orgTypeTable')"
            >组织结构类别</span
          >
          <span
            class="childTabs"
            :class="{ activeLink: settingType == 'orgTypeTree' }"
            @click="settingChange('orgTypeTree')"
            >组织结构类别树</span
          >
          <!-- <span
            class="childTabs"
            :class="{ activeLink: settingType == 'workStation' }"
            @click="settingChange('workStation')"
            >工序管理</span
          > -->
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              v-if="settingType == 'orgTree' || settingType == 'orgTypeTree'"
              type="primary"
              icon="el-icon-download"
              size="small"
              @click="downloadTreeImg"
              >导出</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addNewBtn"
              >新建</el-button
            >
            <!-- <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                v-if="settingType == 'workStation'"
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="工序管理" name="workStationManage">
          <span
            class="childTabs"
            :class="{ activeLink: workStationType == 'workStation' }"
            @click="workStationChange('workStation')"
            >工序管理</span
          >
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip
                class="item"
                content="清除查询条件"
                placement="bottom"
                :open-delay="300"
              >
                <el-button
                  icon="iconfont icon-qingkong"
                  size="small"
                  class="cleanBox"
                  @click="onClear"
                ></el-button>
              </el-tooltip>
              <el-button
                type="primary"
                icon="el-icon-search"
                size="small"
                @click="onSearch"
                >查询</el-button
              >
            </div>
            <el-button
              type="primary"
              icon="el-icon-plus"
              size="small"
              @click="addWorkStationBtn"
              >新建</el-button
            >
            <el-tooltip
              class="item"
              content="查询条件"
              placement="bottom"
              :open-delay="300"
            >
              <el-button
                class="btn_more"
                :class="{ activeUserMore: isMoreSearch }"
                size="small"
                icon="el-icon-d-arrow-right"
                @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="QC设置" name="qcSet">
          <span class="childTabs" 
            :class="{ activeLink: settingType == 'table' }">QC异常类别</span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">
                查询
              </el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="qcResultCodeAdd">
              新建
            </el-button>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                  class="btn_more"
                  :class="{ activeUserMore: isMoreSearch }"
                  size="small"
                  icon="el-icon-d-arrow-right"
                  @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="维修设置" name="repairSet">
          <span class="childTabs"
          :class="{ activeLink: settingType == 'table' }"> 维修设置 </span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">
                查询
              </el-button>
            </div>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="repairCodeAdd">
              新建
            </el-button>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                  class="btn_more"
                  :class="{ activeUserMore: isMoreSearch }"
                  size="small"
                  icon="el-icon-d-arrow-right"
                  @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
        <el-tab-pane label="错误代码" name="errorCode">
          <span class="childTabs"
          :class="{ activeLink: settingType == 'table' }"> 错误代码 </span>
          <div class="btnBox">
            <div class="searchBtnBox" v-if="isMoreSearch">
              <el-tooltip class="item" content="清除查询条件" placement="bottom" :open-delay="300">
                <el-button icon="iconfont icon-qingkong" size="small" class="cleanBox" @click="onClear"></el-button>
              </el-tooltip>
              <el-button type="primary" icon="el-icon-search" size="small" @click="onSearch">
                查询
              </el-button>
            </div>
            <el-button type="primary" icon="el-icon-upload2" size="small" @click="errorCodeUpload">
              导入
            </el-button>
            <el-button type="primary" icon="el-icon-download" size="small" @click="errorCodeExport">
              导出
            </el-button>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="errorCodeAdd">
              新建
            </el-button>
            <el-tooltip class="item" content="查询条件" placement="bottom" :open-delay="300">
              <el-button
                  class="btn_more"
                  :class="{ activeUserMore: isMoreSearch }"
                  size="small"
                  icon="el-icon-d-arrow-right"
                  @click="moreSearchBtn"
              ></el-button>
            </el-tooltip>
          </div>
        </el-tab-pane>
      </el-tabs>
      <el-form
        :inline="true"
        :model="developerSearchForm"
        class="demo-form-inline"
        v-if="
          isMoreSearch &&
          tabPaneValue == 'workStationManage' &&
          workStationType == 'workStation'
        "
        :key="1"
        @submit.native.prevent
      >
        <div class="searchConditionBox">
          <el-form-item label="工序名称" size="small">
            <el-input
              v-model="workStationSearchForm.name"
              placeholder="输入工序名称"
              clearable
              @keyup.enter.native="onSearch"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <el-form
        :inline="true"
        :model="developerSearchForm"
        class="demo-form-inline"
        v-else-if="isMoreSearch && tabPaneValue == 'developer'"
        :key="2"
      >
        <div class="searchConditionBox">
          <el-form-item label="APP" size="small">
            <el-input
              v-model="developerSearchForm.app"
              placeholder="APP名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="邮箱" size="small">
            <el-input
              v-model="developerSearchForm.email"
              placeholder="邮箱"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="公钥" size="small">
            <el-input
              v-model="developerSearchForm.publicKey"
              placeholder="公钥"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="私钥" size="small">
            <el-input
              v-model="developerSearchForm.privateKey"
              placeholder="私钥"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" size="small">
            <el-select
              v-model="developerSearchForm.enable"
              placeholder="选择状态"
              filterable
              clearable
            >
              <el-option label="启用" :value="true"></el-option>
              <el-option label="禁用" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <el-form :inline="true" :model="searchForm" class="demo-form-inline"  v-if="isMoreSearch && tabPaneValue == 'qcSet'" :key="1">
        <div class="searchConditionBox">
          <el-form-item label="不良名称" size="small">
            <el-input
                v-model="searchForm.name"
                placeholder="输入不良名称"
                clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="产品类别" size="small">
            <el-select
              v-model="searchForm.productType"
              placeholder="选择产品类别"
              filterable
              clearable
              @change="productTypeChange"
            >
              <el-option
                v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="不良类别" size="small" prop="type">
            <el-select @change="selectTypeChange"
              v-model="searchForm.type"
              placeholder="选择不良类别"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in qcTypeList"
                :key="index"
                :label="item.title"
                :value="item.code"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="异常类别" size="small" prop="code">
              <el-cascader
                :options="qcDataTypes"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'name',
                  value: 'code',
                }"
                v-model="searchForm.code"
                :show-all-levels="false"
                placeholder="选择所属类别"
                clearable
              ></el-cascader>
            </el-form-item>
        </div>
      </el-form>
      <el-form :inline="true" :model="searchRepairForm" class="demo-form-inline"  v-if="isMoreSearch && tabPaneValue == 'repairSet'" :key="1">
        <div class="searchConditionBox">
          <el-form-item label="名称" size="small">
            <el-input
                v-model="searchRepairForm.name"
                placeholder="输入名称"
                clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="类别" size="small" prop="typeCode">
            <el-select
              v-model="searchRepairForm.typeCode"
              @change="changeType"
              placeholder="选择类别"
              filterable
              clearable
            >
              <el-option
                v-for="(item, index) in typeNameList"
                :key="index"
                :label="item.typeName"
                :value="item.typeCode"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <el-form :inline="true" :model="searchErrorCodeForm" class="demo-form-inline"  v-if="isMoreSearch && tabPaneValue == 'errorCode'" :key="1">
        <div class="searchConditionBox">
          <el-form-item label="类别" size="small" prop="typeCode">
            <el-select v-model="searchErrorCodeForm.type" placeholder="选择类别" filterable clearable>
              <el-option v-for="(item, index) in pullDownData.errorCodeTypeList"
                :key="index"
                :value="item.code"
                :label="item.title"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品类型" size="small" prop="typeCode">
            <el-select v-model="searchErrorCodeForm.productType" placeholder="选择产品类型" filterable clearable>
              <el-option v-for="(item, index) in pullDownData.productTypeList"
                :key="index"
                :value="item.code"
                :label="item.title"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="错误代码" size="small">
            <el-input v-model="searchErrorCodeForm.code" placeholder="输入错误代码" clearable
              @keyup.enter.native="$refs.errorCodePage.search()"></el-input>
          </el-form-item>
          <el-form-item label="名称" size="small">
            <el-input v-model="searchErrorCodeForm.title" placeholder="输入名称" clearable
            @keyup.enter.native="$refs.errorCodePage.search()"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div class="tips tipsBox" v-show="tabPaneValue == 'first' && (settingType == 'orgTree' || settingType == 'orgTypeTree') && isShowTips">
        <span class="title">温馨提示：</span>
        <span class="text">双击标签可操作！</span>
        <i class="el-icon-close close" @click="closeTips"></i>
      </div>
    </div>
    <div class="contentBox">
      <div class="rightContent" v-if="tabPaneValue == 'first' && settingType == 'table'">
        <el-table stripe :data="tableData" style="width: 100%" border height="100%" size="mini" row-key="id"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" default-expand-all>
          <el-table-column type="index" width="50" align="center"></el-table-column>
          <el-table-column prop="name" label="组织名称" min-width="110" header-align="center" show-overflow-tooltip></el-table-column>
          <el-table-column
            prop="typeId"
            label="组织类别"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.type">{{ scope.row.type.name }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="enable"
            label="状态" width="95px"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="textSuccess" v-if="scope.row.enable">启用</span>
              <span class="textWarning" v-else>禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            class-name="operation"
            label="操作"
            align="center"
            width="130px"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="新建"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="addNewBtn($event, scope.row)"
                  class="el-icon-plus"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="editFactoryOrg($event, scope.row)"
                  class="el-icon-edit"
                ></i>
              </el-tooltip>
              <el-tooltip
                v-if="scope.row.enable"
                class="item"
                effect="dark"
                content="禁用"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="disableFactoryOrg($event, scope.row)"
                  class="iconfont icon-jinyong"
                ></i>
              </el-tooltip>
              <el-tooltip
                v-else
                class="item"
                effect="dark"
                content="启用"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="enableFactoryOrg($event, scope.row)"
                  class="iconfont icon-qiyong"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="上移"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="moveUpFactoryOrg($event, scope.row)"
                  class="el-icon-arrow-up"
                ></i>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="下移"
                placement="top"
                :open-delay="300"
              >
                <i
                  @click="moveDownFactoryOrg($event, scope.row)"
                  class="el-icon-arrow-down"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="rightContent"
        v-else-if="tabPaneValue == 'first' && settingType == 'orgTree'"
      >
        <orgTreePage ref="orgTreePage"></orgTreePage>
      </div>
      <div
        class="rightContent"
        v-else-if="tabPaneValue == 'first' && settingType == 'orgTypeTable'"
      >
        <orgTypePage ref="orgTypePage"></orgTypePage>
      </div>
      <div
        class="rightContent"
        v-else-if="tabPaneValue == 'first' && settingType == 'orgTypeTree'"
      >
        <orgTypeTreePage ref="orgTypeTreePage"></orgTypeTreePage>
      </div>
      <workStationPage
        ref="workStationPage"
        v-else-if="
          tabPaneValue == 'workStationManage' &&
          workStationType == 'workStation'
        "
        :workStationSearchForm="workStationSearchForm"
      ></workStationPage>
      <div class="rightContent" v-else-if="tabPaneValue == 'developer'">
        <developerPage
          ref="developerPage"
          :developerSearchForm="developerSearchForm"
        ></developerPage>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'qcSet'">
        <qc-set-page ref="page" :searchForm="searchForm" ></qc-set-page>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'repairSet'">
        <repairSetPage ref="repairSetPage" :searchRepairForm="searchRepairForm"></repairSetPage>
      </div>
      <div class="rightContent" v-else-if="tabPaneValue == 'errorCode'">
        <errorCodePage ref="errorCodePage" :searchErrorCodeForm="searchErrorCodeForm"></errorCodePage>
          <input ref="uploadErrorCodeInput" type="file" @change="fileChange()" style="display: none"/>
      </div>
    </div>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <div
            v-if="settingType == 'table' || settingType == 'orgTree'"
            :key="1"
          >
            <el-form-item label="组织名称" size="small" prop="name">
              <el-input
                v-model="dialogForm.name"
                placeholder="组织结构名称(工厂、车间/仓库、拉线、工序等)"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="上级组织" size="small" prop="parentId">
              <el-cascader
                :options="pullDownData.cascaderOptions"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'name',
                  value: 'id',
                }"
                :show-all-levels="false"
                v-model="dialogForm.parentId"
                @change="cascaderChange($event, 'parentCascader')"
                ref="parentCascader"
                placeholder="选择所属组织"
                clearable
              ></el-cascader>
            </el-form-item>
            <el-form-item label="组织类别" size="small" prop="typeId">
              <el-cascader
                :options="pullDownData.typeList"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'name',
                  value: 'id',
                }"
                :show-all-levels="false"
                v-model="dialogForm.typeId"
                @change="cascaderChange($event, 'typeCascader')"
                ref="typeCascader"
                placeholder="选择组织结构类别"
                clearable
              ></el-cascader>
            </el-form-item>
          </div>
          <div
            v-else-if="
              settingType == 'orgTypeTable' || settingType == 'orgTypeTree'
            "
            :key="2"
          >
            <el-form-item label="类别名称" size="small" prop="typeName">
              <el-input
                v-model="dialogForm.typeName"
                placeholder="组织结构类别名称"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="上级类别" size="small" prop="typeParentId">
              <el-cascader
                :options="pullDownData.typeList"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'name',
                  value: 'id',
                }"
                :show-all-levels="false"
                v-model="dialogForm.typeParentId"
                @change="cascaderChange($event, 'parentCascader')"
                ref="parentCascader"
                placeholder="选择所属类别"
                clearable
              ></el-cascader>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>
<script>
import {
  apiFactoryOrganizationTree,
  apiFactoryOrgAdd,
  apiFactoryOrgUpdate,
  apiFactoryOrgDisable,
  apiFactoryOrgEnable,
  apiFactoryOrgMoveUp,
  apiFactoryOrgMoveDown,
  apiFactoryOrgTypeList,
  apiFactoryOrgTypeAdd,
  apiFactoryOrgTypeUpdate,
  apiFactoryOrgTypeDisable,
  apiFactoryOrgTypeEnable,
  apiFactoryOrgTypeMoveUp,
  apiFactoryOrgTypeMoveDown,
  apiLabelType,
  apiGetTypeList,
  apiQcCodeTree,
} from "@/api/plantSetting.js";
import { apiUploadFile } from "@/api/filesUpload.js";
import { apiErrorCodeImport,apiErrorCodeTypeList,apiErrorCodeExport } from "@/api/errorCode.js";
import {
  apiProductTypeList,
} from "@/api/productionOrder.js";
import myDialog from "@/components/myDialog.vue";
import orgTreePage from "./components/orgTreePage.vue";
import orgTypePage from "./components/orgTypePage.vue";
import orgTypeTreePage from "./components/orgTypeTreePage.vue";
import workStationPage from "./components/workStationPage.vue";
import developerPage from "./components/developerPage.vue";
import qcSetPage from "./components/qcSetPage.vue";
import repairSetPage from "./components/repairSetPage.vue";
import errorCodePage from "./components/errorCodePage.vue";

export default {
  lastModuleConfig: { modulePath: "/homePage/plantSetting", topTabVar: "tabPaneValue", topTabs: ["first", "workStationManage", "qcSet", "repairSet", "errorCode"], subTabs: { settingType: [], workStationType: [] } },
  components: {
    myDialog,
    orgTreePage,
    orgTypePage,
    orgTypeTreePage,
    workStationPage,
    developerPage,
    qcSetPage,
    repairSetPage,
    errorCodePage
  },
  data() {
    return {
      tabPaneValue: "first",
      settingType: "table",
      workStationType: "workStation",
      isMoreSearch: false,
      pullDownData: {
        cascaderOptions: [],
        typeList: [],
        labelTypeList: [],
        productTypeList: [],
        errorCodeTypeList: [],
      },
      qcDataTypes: [],
      qcTypeList:[{code:"FQC",title:"FQC"},{code:"OQC",title:"OQC"}], 
      // 工序当前生产线
      currentNodeKey: "",
      workStationSearchForm: {},
      isShowTips: true,
      developerSearchForm: {},
      tableData: [],
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {
        name: [
          { required: true, message: "组织名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change",
          },
        ],
        parentId: [
          { required: true, message: "父级结构不能为空！", trigger: "change" },
        ],
        typeId: [
          { required: true, message: "组织类别不能为空！", trigger: "change" },
        ],
        typeName: [
          { required: true, message: "类别名称不能为空！", trigger: "blur" },
          {
            min: 2,
            max: 64,
            message: "长度在 2 到 64 个字符",
            trigger: "change",
          },
        ],
        typeParentId: [
          { required: true, message: "父级类别不能为空！", trigger: "change" },
        ],
      },
      typeId: "",
      labelWidth: this.$store.state.labelWidth,

      //qcSet
      searchForm: {},
      searchRepairForm:{},
      searchErrorCodeForm:{},
      typeNameList: [],
    };
  },
  watch: {
    tabPaneValue: function (newVal) {
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (newVal == "first") {
          if (this.settingType == "table") {
            this.getFactoryOrganizationTree();
          } else if (this.settingType == "orgTree") {
            this.$refs.orgTreePage.getFactoryOrganization();
          } else if (this.settingType == "orgTypeTable") {
            this.$refs.orgTypePage.getFactoryOrgTypeGrid();
          } else if (this.settingType == "orgTypeTree") {
            this.$refs.orgTypeTreePage.getFactoryOrgTypeShow();
          }
        } else if (newVal == "workStation"){
          this.$refs.workStationPage.currentNodeKey = this.currentNodeKey;
          this.$refs.workStationPage.getFactoryProductionLineData();
        } else if(newVal =="qcSet"){
          this.$refs.page.getProductTypeList();
          this.$refs.page.search("",true);
        } else if(newVal =="repairSet"){
          this.$refs.repairSetPage.search("",true);
        } else if(newVal =="errorCode"){
          this.$refs.errorCodePage.search("",true);
        } else if (newVal == "workStationManage"){
          this.$refs.workStationPage.currentNodeKey = this.currentNodeKey;
          this.$refs.workStationPage.getFactoryProductionLineData();
        }else {
          this.$refs.page.currentNodeKey = this.currentNodeKey;
          this.$refs.page.search();
        }
      });
    },
  },
  methods: {
    // 上传错误代码
    errorCodeUpload(){
      this.$nextTick(() => {
        this.$refs.uploadErrorCodeInput.click();
      });
    },
    // 文件上传
    async fileChange() {
      let files = this.$refs.uploadErrorCodeInput.files;
      if (files.length) {
        let fd = new FormData();        
        fd.append("file", files[0]);
        let res = await apiUploadFile(fd);
        if (res.code == 0) {
          this.$refs.uploadErrorCodeInput.value = "";
          const resImport = await apiErrorCodeImport({
            id: this.tabPaneValue,
            fid: res.fid,
          });
          if (resImport.code == 0) {
            this.$message({
              type: "success",
              message: resImport.msg,
            });
            this.$refs.errorCodePage.search();
          }
        }
      }
    },
    // 导出错误代码
    errorCodeExport() {
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiErrorCodeExport({
          ...this.searchErrorCodeForm,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    // 切换一级面板
    tabPaneClick(tab) {
      this.tabPaneValue = tab.name;
    },
    // 切换系统设置子标签
    settingChange(value) {
      this.settingType = value;
      this.$moreSearchStyle();
      this.$nextTick(() => {
        if (this.settingType == "table") {
          this.getFactoryOrganizationTree("");
        } else if (this.settingType == "orgTree") {
          this.$refs.orgTreePage.getFactoryOrganization("");
        } else if (this.settingType == "orgTypeTable") {
          this.$refs.orgTypePage.getFactoryOrgTypeGrid();
        } else if (this.settingType == "orgTypeTree") {
          this.$refs.orgTypeTreePage.getFactoryOrgTypeShow();
        } else if (this.settingType == "workStation") {
          this.$refs.workStationPage.currentNodeKey = this.currentNodeKey;
          this.$refs.workStationPage.getFactoryProductionLineData();
        }
      });
    },
    // 切换工序管理
    workStationChange(value) {
      this.workStationType = value;
    },
    // 更多查询
    moreSearchBtn() {
      this.isMoreSearch = !this.isMoreSearch;
      this.$moreSearchStyle();
    },
    // 工厂设置组织结构
    async getFactoryOrganizationTree(remove, callback) {
      if (remove != "noRemove") {
        this.tableData = [];
      }
      const res = await apiFactoryOrganizationTree();
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pullDownData.cascaderOptions = res.data;
        if (callback) callback();
      }
    },
    // 添加组织结构
    addNewBtn(e, row) {
      if (this.settingType == "table" || this.settingType == "orgTree") {
        this.dialogTitle = "新建组织";
        this.$refs.myDialog.dialogVisible = true;
        this.$set(this.dialogForm, "parentId", row ? row.id : "");
        this.$set(this.dialogForm, "typeId", this.typeId || "");
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.dialogTitle = "新建类别";
        this.$refs.myDialog.dialogVisible = true;
        this.$set(this.dialogForm, "typeParentId", row ? row.id : "");
      }
    },
    // 添加工序
    addWorkStationBtn() {
      if (this.workStationType == "workStation") {
        this.$refs.workStationPage.addNewBtn();
      }
    },
    // 确认新建
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title == "新建组织") {
            res = await apiFactoryOrgAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getSettingData("noRemove");
              this.$message({
                message: "新建成功",
                type: "success",
              });
            }
          } else if (title == "修改组织") {
            res = await apiFactoryOrgUpdate({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getSettingData("noRemove");
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          } else if (title == "新建类别") {
            res = await apiFactoryOrgTypeAdd({
              name: this.dialogForm.typeName,
              parentId: this.dialogForm.typeParentId,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getSettingData("noRemove");
              this.$message({
                message: "新建成功",
                type: "success",
              });
            }
          } else if (title == "修改类别") {
            res = await apiFactoryOrgTypeUpdate({
              id: this.dialogForm.id,
              name: this.dialogForm.typeName,
              parentId: this.dialogForm.typeParentId,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.getSettingData("noRemove");
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      if (this.settingType == "table" || this.settingType == "orgTree") {
        this.typeId = this.dialogForm.typeId;
        this.$refs.parentCascader.$refs.panel.activePath = [];
        this.$refs.typeCascader.$refs.panel.activePath = [];
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$refs.parentCascader.$refs.panel.activePath = [];
      }
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 清除查询
    onClear() {
      if (
        this.tabPaneValue == "workStationManage" &&
        this.workStationType == "workStation"
      ) {
        this.workStationSearchForm = {};
        this.$refs.workStationPage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.workStationPage.getFactoryWorkStationSearch();
        });
      } else if (this.tabPaneValue == "developer") {
        this.developerSearchForm = {};
        this.$refs.developerPage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.developerPage.getOpenKeySearch();
        });
      } else if (this.tabPaneValue == "errorCode") {
        this.searchErrorCodeForm = {};
        this.$refs.errorCodePage.pagination.currentPage = 1;
        this.$nextTick(() => {
          this.$refs.errorCodePage.search();
        });
      } else {
        this.searchForm = {}
        this.$refs.page.currentChange(1)
      }
    },
    qcResultCodeAdd() {
      this.$refs.page.openAdd();
    },
    repairCodeAdd() {
      this.$refs.repairSetPage.openAdd();
    },
    errorCodeAdd() {
      this.$refs.errorCodePage.openAdd();
    },
    // 确认查询
    onSearch() {
      if (
        this.tabPaneValue == "workStationManage" &&
        this.workStationType == "workStation"
      ) {
        this.$refs.workStationPage.pagination.currentPage = 1;
        this.$refs.workStationPage.getFactoryWorkStationSearch();
      } else if (this.tabPaneValue == "developer") {
        this.$refs.developerPage.pagination.currentPage = 1;
        this.$refs.developerPage.getOpenKeySearch();
      } else if (this.tabPaneValue === 'qcSet') {
        this.$refs.page.currentChange(1)
      } else if (this.tabPaneValue === 'repairSet') {
        this.$refs.repairSetPage.currentChange(1)
      } else if (this.tabPaneValue === 'errorCode') {
        this.$refs.errorCodePage.currentChange(1)
      }
    },
    // 关闭温馨提示
    closeTips() {
      this.isShowTips = false;
      this.$moreSearchStyle();
    },
    // 修改组织架构
    editFactoryOrg(e, row) {
      this.dialogTitle = "修改组织";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id,
        name: row.name,
        parentId: row.parent ? row.parent.id : undefined,
        typeId: row.type.id,
      };
    },
    // 修改组织架构类别
    editFactoryOrgType(e, row) {
      this.dialogTitle = "修改类别";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id,
        typeName: row.name,
        typeParentId: row.parent ? row.parent.id : undefined,
      };
    },
    // 禁用
    disableFactoryOrg(e, row) {
      e.target.blur();
      let res = {};
      if (this.settingType == "table" || this.settingType == "orgTree") {
        this.$allOperation(row, "禁用", "结构").then(async () => {
          res = await apiFactoryOrgDisable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "禁用成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$allOperation(row, "禁用", "类别").then(async () => {
          res = await apiFactoryOrgTypeDisable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "禁用成功",
              type: "success",
            });
          }
        });
      }
    },
    // 启用
    enableFactoryOrg(e, row) {
      e.target.blur();
      let res;
      if (this.settingType == "table" || this.settingType == "orgTree") {
        this.$allOperation(row, "启用", "结构").then(async () => {
          res = await apiFactoryOrgEnable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "启用成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$allOperation(row, "启用", "类别").then(async () => {
          res = await apiFactoryOrgTypeEnable({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "启用成功",
              type: "success",
            });
          }
        });
      }
    },
    // 上移
    moveUpFactoryOrg(e, row) {
      e.target.blur();
      let res = {};
      if (this.settingType == "table" || this.settingType == "orgTree") {
        this.$confirm(`是否上移【${row.name}】？`, "上移结构", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiFactoryOrgMoveUp({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "上移成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$confirm(`是否上移【${row.name}】？`, "上移类别", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiFactoryOrgTypeMoveUp({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "上移成功",
              type: "success",
            });
          }
        });
      }
    },
    // 下移
    moveDownFactoryOrg(e, row) {
      e.target.blur();
      let res = {};
      if (this.settingType == "table" || this.settingType == "orgTree") {
        this.$confirm(`是否下移【${row.name}】？`, "下移结构", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiFactoryOrgMoveDown({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "下移成功",
              type: "success",
            });
          }
        });
      } else if (
        this.settingType == "orgTypeTable" ||
        this.settingType == "orgTypeTree"
      ) {
        this.$confirm(`是否下移【${row.name}】？`, "下移类别", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          res = await apiFactoryOrgTypeMoveDown({
            id: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getSettingData("noRemove");
            this.$message({
              message: "下移成功",
              type: "success",
            });
          }
        });
      }
    },
    // 联级选择器改变时触发
    cascaderChange(val, ref) {
      val && this.$refs[ref].toggleDropDownVisible();
    },
    downloadTreeImg() {
      let name =
        this.settingType == "orgTree" ? "组织结构树" : "组织结构类别树";
      this.$confirm(`确定导出【${name}】吗？`, "导出图片", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$canvasDownload(
          ".org-tree-container .org-tree .org-tree-node",
          name
        );
      });
    },
    getSettingData(remove, callback) {
      if (this.tabPaneValue == "first") {
        if (this.settingType == "table") {
          this.getFactoryOrganizationTree(remove, callback);
        } else if (this.settingType == "orgTree") {
          this.$refs.orgTreePage.getFactoryOrganization(remove, callback);
        } else if (this.settingType == "orgTypeTable") {
          this.$refs.orgTypePage.getFactoryOrgTypeGrid(remove);
        } else if (this.settingType == "orgTypeTree") {
          this.$refs.orgTypeTreePage.getFactoryOrgTypeShow(remove);
        }
      } else if (this.tabPaneValue == "workStationManage") {
        this.$refs.workStationPage.getFactoryProductionLineData();
        this.$refs.workStationPage.getFactoryWorkStationSearch(
          remove,
          callback
        );
      } else if (this.tabPaneValue == "developer") {
        this.$refs.developerPage.getOpenKeySearch(remove, callback);
      } else if (this.tabPaneValue == "repairSet") {
        if (callback) callback();
      } else if (this.tabPaneValue == "errorCode") {
        if (callback) callback();
      }
    },
    // 组织结构类别
    async getTypeList() {
      const res = await apiFactoryOrgTypeList();
      if (res.code == 0) {
        this.pullDownData.typeList = res.data;
      }
    },
    // 标签类别
    async getLabelType() {
      const res = await apiLabelType();
      if (res.code == 0) {
        this.pullDownData.labelTypeList = res.data;
      }
    },
    async getTypeNameList(){ 
      const res = await apiGetTypeList({
        
      });
      if (res.code == 0) {
        this.typeNameList = res.data;
      }
    },
    changeType(code) {
      this.typeName= this.typeNameList.find(item => item.typeCode == code) 
    },
    // 查询条件-产品类别改变
    productTypeChange() {
      
    },
    // 产品类别下拉数据
    async getProductTypeList() {
      const res = await apiProductTypeList();
      if (res.code == 0) {
        this.pullDownData.productTypeList = res.data;
      }
    },
    async getErrorCodeTypeList() {
      const res = await apiErrorCodeTypeList();
      if (res.code == 0) {
        this.pullDownData.errorCodeTypeList = res.data;
      }
    },
    
    selectTypeChange(value){
      if(value=='FQC'){
        this.getFQCResultCode('FQC',null);
      }else if(value=='OQC'){
        this.getOQCResultCode('OQC',null);
      }
    },
    async getFQCResultCode(type,callback){ 
      const res = await apiQcCodeTree({
        showLastLevel:false,
        type:type
      });
      if (res.code == 0) {
        this.qcDataTypes = res.data;
        if (callback) callback();
      }
    },
    async getOQCResultCode(type,callback){ 
      const res = await apiQcCodeTree({
        showLastLevel:false,
        type:type
      });
      if (res.code == 0) {
        this.qcDataTypes = res.data;
        if (callback) callback();
      }
    },
    callback() {
      this.getTypeList();
      this.getLabelType();
      this.getTypeNameList();
      this.getProductTypeList();
      this.getErrorCodeTypeList();
    },
  },
  activated() {
    window.onresize = () => {
      document.querySelector(".contentBox").style.top =
        document.querySelector(".header").offsetHeight + "px";
    };
    this.getSettingData("", this.callback);
  },
  deactivated() {
    window.onresize = null;
  },
};
</script>

<style lang="less" scoped>
</style>